export const GET_CURRENT_USERS = "GET_CURRENT_USERS";
export const REFRESH_CURRENT_USERS = "REFRESH_CURRENT_USERS";
export const RESET_CURRENT_USERS = "RESET_CURRENT_USERS";
export const SET_CURRENT_USERS_REQUEST_STATUS = "SET_CURRENT_USERS_REQUEST_STATUS";
